export default __webpack_public_path__ + "static/media/ISWEC-17.b577468c.pdf";